// Presentation only: identity remains company + type + onboarding owner in SQL.
export function reviewPresentation(doc, t) {
  const text = (key, fallback, params) =>
    typeof t === "function"
      ? t(key, params)
      : fallback;

  if (doc.scope === "FOUNDER") {
    return {
      name: doc.document_type_name,
      context: text(
        "adminReview.presentation.founder",
        `Pemegang Saham Pendiri — ${doc.related_name}`,
        { name: doc.related_name },
      ),
    };
  }

  if (doc.section === "C") {
    return {
      name: doc.document_type_name,
      context: text(
        "adminReview.presentation.management",
        "Management",
      ),
    };
  }

  return {
    name:
      doc.document_type_name === "NPWP"
        ? text(
            "adminReview.presentation.companyNpwp",
            "NPWP Perseroan",
          )
        : doc.document_type_name,
    context: text(
      "adminReview.presentation.company",
      "Perseroan / Emiten",
    ),
  };
}
